import React from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import './Pages.css';

const FAQ = () => {
  return (
    <Container className="page-container">
      <Row className="page-header">
        <Col>
          <h1>Frequently Asked Questions</h1>
          <div className="header-underline"></div>
        </Col>
      </Row>
      
      <Row className="page-content">
        <Col>
          <p className="faq-intro">
            Find answers to the most common questions about our products, services, and policies.
            If you can't find the answer you're looking for, please don't hesitate to <a href="/contact">contact us</a>.
          </p>
          
          <Accordion defaultActiveKey="0" className="faq-accordion">
            <Accordion.Item eventKey="0">
              <Accordion.Header>How do I know the diamonds are authentic?</Accordion.Header>
              <Accordion.Body>
                All our diamonds come with certification from internationally recognized gemological laboratories such as GIA, IGI, or HRD. 
                These certificates verify the authenticity and quality of each diamond. Additionally, we offer a 100% money-back guarantee 
                if any diamond is found to be not as described.
              </Accordion.Body>
            </Accordion.Item>
            
            <Accordion.Item eventKey="1">
              <Accordion.Header>What is your return policy?</Accordion.Header>
              <Accordion.Body>
                We offer a 30-day return policy for all our products. If you're not completely satisfied with your purchase, 
                you can return it within 30 days for a full refund or exchange. The item must be in its original condition 
                and packaging. Please note that custom-made jewelry cannot be returned unless there is a manufacturing defect.
              </Accordion.Body>
            </Accordion.Item>
            
            <Accordion.Item eventKey="2">
              <Accordion.Header>Do you offer international shipping?</Accordion.Header>
              <Accordion.Body>
                Yes, we ship to most countries worldwide. International shipping typically takes 5-10 business days, 
                depending on the destination. Please note that customers are responsible for any customs duties or taxes 
                that may apply in their country.
              </Accordion.Body>
            </Accordion.Item>
            
            <Accordion.Item eventKey="3">
              <Accordion.Header>How do I care for my diamond jewelry?</Accordion.Header>
              <Accordion.Body>
                To keep your diamond jewelry looking its best, clean it regularly with a mild soap solution and a soft brush. 
                Avoid wearing your jewelry while swimming, bathing, or doing household chores. Store your jewelry in a fabric-lined 
                box away from other pieces to prevent scratching. We recommend having your jewelry professionally cleaned and 
                inspected once a year.
              </Accordion.Body>
            </Accordion.Item>
            
            <Accordion.Item eventKey="4">
              <Accordion.Header>Can I customize a piece of jewelry?</Accordion.Header>
              <Accordion.Body>
                Yes, we offer custom design services. You can work with our experienced designers to create a unique piece 
                that reflects your personal style. The process typically takes 3-4 weeks, depending on the complexity of the design. 
                Please <a href="/contact">contact us</a> to discuss your custom jewelry needs.
              </Accordion.Body>
            </Accordion.Item>
            
            <Accordion.Item eventKey="5">
              <Accordion.Header>What payment methods do you accept?</Accordion.Header>
              <Accordion.Body>
                We accept all major credit cards (Visa, MasterCard, American Express), PayPal, and bank transfers. 
                For in-store purchases, we also accept cash and debit cards. All online transactions are secured with 
                industry-standard encryption to protect your personal information.
              </Accordion.Body>
            </Accordion.Item>
            
            <Accordion.Item eventKey="6">
              <Accordion.Header>Do you offer jewelry repair services?</Accordion.Header>
              <Accordion.Body>
                Yes, we provide comprehensive jewelry repair services, including ring resizing, stone replacement, 
                chain repair, and prong retipping. All repairs are performed by our skilled craftsmen. Please bring your 
                jewelry to our store or contact us for more information about our repair services.
              </Accordion.Body>
            </Accordion.Item>
            
            <Accordion.Item eventKey="7">
              <Accordion.Header>What is your warranty policy?</Accordion.Header>
              <Accordion.Body>
                All our jewelry comes with a one-year warranty against manufacturing defects. This warranty covers 
                repairs or replacement if the item has a manufacturing defect. The warranty does not cover damage 
                due to normal wear and tear, accidents, or improper care. Extended warranty options are available 
                for purchase.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default FAQ; 